const Fonts = {
  brand: "Mitr_300Light",
  brandBold: "Mitr_500Medium",
  brand2: "Chonburi_400Regular",
  read: "Sarabun_400Regular",
  readBold: "Sarabun_700Bold",
}

export default Fonts